import Cookies from "universal-cookie";

const cookies = new Cookies(null, { path: "/" });

/**
 * Function to set cookie client side
 */
export const cookieFn = {
  setCookie: (key: string, value: string, domain: string) => {
    cookies.set(key, value, {
      // domain:  "",
      path: "/",
      sameSite: "strict",
    });
  },
  deleteCookie: (key: string, domain: string) => {
    cookies.remove(key, {
      path: "/",
      // domain: domain ? `.${stripProtocol(domain)}` : "",
    });
  },
  getCookie: (key: string) => {
    return cookies.get(key);
  },
};
